import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import useWindowDimensions from "./WindowDimensions";
import IconButton from "@material-ui/core/IconButton";
import GetAppIcon from "@material-ui/icons/GetApp";
import { connect } from "react-redux";
import { CircularProgress, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const CarouselDisplay = ({ open, setOpen, ...rest }) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();

  const renderCarousel = () => {
    if (rest.fetchImageLoading) {
      return (
        <div className={classes.paper}>
          <CircularProgress color="primary" />
        </div>
      );
    }

    if (rest.imageUrls.length > 0) {
      return (
        <Carousel>
          {rest.imageUrls.map((image) => (
            <div key={image} className={classes.paper}>
              <IconButton
                style={{ position: "absolute", right: 30, bottom: 10 }}
                onClick={() => window.open(image, "_blank").focus()}
              >
                <GetAppIcon />
              </IconButton>
              <div style={{ width: width * 0.23 }}>
                <img src={image} alt="eventImages" />
              </div>
            </div>
          ))}
        </Carousel>
      );
    }

    return (
      <div className={classes.paper}>
        <Typography>No images found</Typography>
      </div>
    );
  };

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={() => setOpen(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div style={{ width: width * 0.5 }}>{renderCarousel()}</div>
      </Fade>
    </Modal>
  );
};

const mapStateToProps = ({ events }) => {
  const { imageUrls, fetchImageLoading } = events;

  return { imageUrls, fetchImageLoading };
};

export default connect(mapStateToProps)(CarouselDisplay);
